var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-content',[_c('h1',[_vm._v("Error 500")]),_c('p',[_vm._v("\n            Server load error, please contact an administrator.\n        ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }